import { SignalRModuleType, SignalRRecordType } from "../enums";
import { ModifyUser } from "../user/modifyUser";
var SignalrNotification = /** @class */ (function () {
    function SignalrNotification(obj) {
        this.id = obj && obj.id || "";
        this.module = obj && obj.module || SignalRModuleType.Unknown;
        this.subject = obj && obj.subject || "";
        this.title = obj && obj.title || "";
        this.body = obj && obj.body || "";
        this.recordId = obj && obj.recordId || "";
        this.recordType = obj && obj.recordType || SignalRRecordType.Unknown;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
    return SignalrNotification;
}());
export { SignalrNotification };
